import { OrderType } from './OrderType';
export class TIF {
    constructor(type, expirationTime = undefined) {
        this.type = type;
        this.expirationTime = expirationTime;
    }
    static handleNewExpireTime(date) {
        if (!date)
            return;
        const now = new Date();
        return date >= now ? date : now;
    }
    static getDefaultExpireTimeForOrderType(ordType, instrument) {
        let date = null;
        switch (ordType) {
            case OrderType.Market:
                date = TIF.expireTimeTIF_Market;
                break;
            case OrderType.Limit:
            case OrderType.StopLimit:
                date = TIF.expireTimeTIF_Limit;
                break;
            case OrderType.Stop:
            case OrderType.TrailingStop:
                date = TIF.expireTimeTIF_Stop;
                break;
        }
        if (date && (instrument === null || instrument === void 0 ? void 0 : instrument.isFuturesSymbol()) && instrument.LastTradeDate < date) {
            date = instrument.LastTradeDate;
        }
        return date !== null && date !== void 0 ? date : new Date();
    }
}
TIF.expireTimeTIF_Market = new Date();
TIF.expireTimeTIF_Limit = new Date();
TIF.expireTimeTIF_Stop = new Date();
